(() => {
  const catalog = document.querySelector('.catalog');
  if (!catalog) return;
  const form = catalog.querySelector('.catalog__layout');
  const filters = catalog.querySelector('.catalog__filters');
  const mobile = window.matchMedia('(max-width: 760px)');
  const setFilterLayout = () => { if (filters) filters.open = !mobile.matches; };
  setFilterLayout();
  mobile.addEventListener('change', setFilterLayout);
  catalog.querySelector('#catalog-sort')?.addEventListener('change', () => form.requestSubmit());
  form.addEventListener('submit', () => {
    // Unset price bounds must not become zero-valued filters.
    form.querySelectorAll('input[type="number"]').forEach(input => {
      input.disabled = input.value === '';
    });
  });
  window.addEventListener('pageshow', () => {
    form.querySelectorAll('input[type="number"]').forEach(input => { input.disabled = false; });
  });
  catalog.classList.add('is-enhanced');
})();
